// @file Whiteboard Panels store. Consolidate the visibility state of the whiteboard panels here.
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWhiteboardPanelsStore = defineStore('whiteboardPanels', () => {
  const xCardTemplatesPanel = ref(false)

  return {
    xCardTemplatesPanel,
  }
})
